import { ProjectRouteStationWithParam } from 'src/app/project/shared/interfaces/project-route-station.class';

/**
 * Eine Spalte der SWA-Visualisierung, gruppiert nach der Position X.
 * top (y === 1)    = Mittelstreifen-Aufstellung (obere Reihe),
 * bottom (y === 2) = Randstreifen-Aufstellung (untere Reihe).
 * So stehen Stationen mit gleicher X-Koordinate oben und unten in derselben Spalte.
 */
export interface StationColumn {
  x: number;
  top: ProjectRouteStationWithParam[];
  bottom: ProjectRouteStationWithParam[];
}

export interface StationColumns {
  columns: StationColumn[];
  unassigned: ProjectRouteStationWithParam[];
}

export function buildStationColumns(stations: ProjectRouteStationWithParam[] | undefined): StationColumns {
  const map = new Map<number, StationColumn>();
  const unassigned: ProjectRouteStationWithParam[] = [];

  for (const station of stations ?? []) {
    const y = station.routeStation?.y;
    if (y !== 1 && y !== 2) { unassigned.push(station); continue; }
    const x = station.routeStation?.x ?? 0;
    let column = map.get(x);
    if (!column) { column = { x, top: [], bottom: [] }; map.set(x, column); }
    (y === 1 ? column.top : column.bottom).push(station);
  }

  const columns = [...map.values()].sort((a, b) => a.x - b.x);
  return { columns, unassigned };
}
